import { render, staticRenderFns } from "./CourseStructureModuleSlidebar.vue?vue&type=template&id=056d3581"
import script from "./CourseStructureModuleSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseStructureModuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports